import type { Page } from '@inertiajs/core';
import { router } from '@inertiajs/vue3';
import _ from 'lodash';

/**
 * Runs the callback once the deferred `url_filter_skus` has loaded, or right away when the page doesn't defer it.
 * Returns the listener remover while it is still waiting.
 */
export const whenUrlFilterSkusLoaded = (page: Page, callback: () => void): (() => void) | undefined => {
    if (page.props.url_filter_skus !== undefined || !page.deferredProps?.['url-filters']) {
        callback();
        return undefined;
    }

    // `finish` also fires when the deferred request fails, so the callback runs either way.
    const removeListener = router.on('finish', event => {
        if (!_.includes(event.detail.visit.only, 'url_filter_skus')) {
            return;
        }

        removeListener();
        callback();
    });

    return removeListener;
};
